import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Page from 'flow/components/Setting/Page';
import Icon from 'flow/components/ui-components/Icon';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectOmniTicketQueueMappings } from 'flow/selectors/queue-selectors';
import { PbxParams } from 'flow/types/Params';
import { getOmnichannelTypeName } from 'flow/utils/ticket-utils';
import { getOmnichannelChannelTypeIconKey } from 'flow/utils/omnichannel-utils';

const OmniChannelAccountList = () => {
    const { i18next } = useAppContext();
    const { queueKey, channelType } = useParams<PbxParams>();
    const history = useHistory();

    const omniChannelMappings = useAppSelector((state) =>
        selectOmniTicketQueueMappings(state, queueKey),
    );

    const filteredMappings = omniChannelMappings?.filter(
        (mapping) => mapping.get('channelType') === channelType,
    );

    const handleBack = () => {
        history.goBack();
    };

    const channelTypeName = getOmnichannelTypeName(channelType, i18next);
    const title = channelTypeName
        ? i18next.t('pbx.accounts.type_connected', {
              type: channelTypeName,
          })
        : i18next.t('pbx.accounts.connected');

    const channelTypeIcon = getOmnichannelChannelTypeIconKey(channelType);

    return (
        <Page header={title} onClickBack={handleBack}>
            <div className="mx-auto w-full max-w-3xl p-4">
                {filteredMappings?.size > 0
                    ? filteredMappings.map((mapping, index) => (
                          <div
                              key={mapping.get(
                                  'omniTicketQueueMappingEntityKey',
                              )}
                              className="flex items-center justify-between py-4"
                          >
                              <div className="flex items-center gap-x-3">
                                  {channelTypeIcon ? (
                                      <Icon iconKey={channelTypeIcon} />
                                  ) : null}
                                  <span className="text-base text-gray-600">
                                      {mapping.get(
                                          'externalReferenceDisplayName',
                                      ) || mapping.get('externalReferenceId')}
                                  </span>
                              </div>
                              <span className="text-xs text-gray-400">
                                  {mapping.get('externalReferenceAccountName')}
                              </span>
                          </div>
                      ))
                    : null}
            </div>
        </Page>
    );
};

export default OmniChannelAccountList;
